import * as utils from "../utils/utils.js";
import * as utilsAgZone from "../subpage_agZone/helpers/agzStructure.js";

function agZoneTheme(sparkThemeConfig) {
  
  if (utils.validateEntireSubpageTheme(sparkThemeConfig[0].baseThemeClass)) {
    utils.applyThemeClass(sparkThemeConfig[0].baseThemeClass);
    utilsAgZone.createHeader(sparkThemeConfig);
    utilsAgZone.createFooter(sparkThemeConfig);

    $('link[href*="favicon"]').each(function () {
      $(this).attr(
        "href",
        `${CLIENTRESOURCEPATH}dist/images/agZone/favicon.ico?sv=${SITEVERSION}`
      );
    });
  }

  if (utils.validateLandingPage(sparkThemeConfig[0].landingThemeClass)) {
    utilsAgZone.createContent(sparkThemeConfig);

    $(window).load(function () {
      $("#goog-gt-tt").remove();
    });
  }
}

export { agZoneTheme };
